import { useEffect, useContext } from 'react';
import { Topic, messageFactory, useAuthStateStore, } from '@annunciate/core';
import { Oidc } from '@annunciate/web/dist/context';
import { useOnNavigate } from '../hooks';
const setToken = useAuthStateStore.getState().setToken;
export const useLoginFinalization = ({ silent = false, postLoginRedirectUri, } = {}) => {
    const ctx = useContext(Oidc);
    const onNavigate = useOnNavigate();
    useEffect(() => {
        async function run() {
            if (silent) {
                ctx.signInSilentCallback();
            }
            else {
                const user = await ctx.signInCallback();
                if (user?.id_token) {
                    setToken(user.id_token);
                }
                const statePostLoginRedirect = user?.state
                    ?.postLoginRedirectUri;
                if (statePostLoginRedirect) {
                    await messageFactory(Topic.APP_AUTHENTICATION_COMPLETED);
                    onNavigate(statePostLoginRedirect);
                    return;
                }
                let url = '/';
                if (postLoginRedirectUri) {
                    const parsed = new URL(postLoginRedirectUri);
                    if (parsed.origin === window.location.origin) {
                        url = parsed.pathname;
                    }
                }
                await messageFactory(Topic.APP_AUTHENTICATION_COMPLETED);
                onNavigate(url);
            }
        }
        run();
    }, []);
};
//# sourceMappingURL=useLoginFinalization.js.map